import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogIn } from 'lucide-react';

const Login = ({ onClose }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const submittingRef = useRef(false);

  useEffect(() => {
    if (!authLoading && isAuthenticated && !loading && !submittingRef.current) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, authLoading, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading || submittingRef.current) return;

    setError('');
    setLoading(true);
    submittingRef.current = true;

    try {
      const result = await login(username, password);

      if (result.success) {
        if (onClose) {
          onClose();
        } else {
          navigate('/', { replace: true });
        }
      } else {
        setError(result.error || 'Error al iniciar sesión');
      }
    } finally {
      submittingRef.current = false;
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-6">
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md w-full max-w-md">
        <div className="flex flex-col items-center justify-center mb-6">
          <img src="/escudoMNLS.png" alt="Escudo MNLS" className="h-20 w-20 sm:h-24 sm:w-24 object-contain drop-shadow-md mb-3" />
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Iniciar Sesión</h2>
        </div>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Usuario</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <p className="text-sm text-gray-600 mt-4 text-center">
          Si no tienes usuario, contacta al administrador
        </p>
      </div>
    </div>
  );
};

export default Login;
